<template>
  <div class="card-903 col p-0 m-0">
    <m-a v-if="imageLink!=null" :target="linkTarget" :href="imageLink">
      <img :src="image" :alt="alt" class="w-100 card-903-image "/>
    </m-a>
    <img :src="image" :alt="alt" class="w-100 card-903-image" v-else/>
    <div class="card-903-content-wrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import {CardProps} from "./CardProps";
import mA from '../Tags/A'

export default {
  name: "C903",
  props: {
    ...CardProps
  },
  components: {mA},
}
</script>

<style scoped>
.card-903 {
  height: 460px;
  border: 1px solid rgba(0, 0, 0, 33%);
}

.card-903-image {
  width: 100%;
  height: 70%;
  object-fit: cover;
}

@media only screen and (max-width: 500px) {
  .card-903-image {
    width: 100%;
    height: 50%;
  }

  .card-903 {
    height: 333px;
  }
}

</style>